import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";

import React, { useState, useEffect } from "react";
import { AvForm } from "availity-reactstrap-validation";
import TextField from "@material-ui/core/TextField";
import { Button, Alert, FormGroup, Label, Row, Col } from "reactstrap";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Credentiallist from "./Credentiallist.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Radio from "@material-ui/core/Radio";
const { portValidator } = require("port-validator");

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Progress(props) {
  const { submitted, refreshPage } = props;

  const delay = 3;

  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer1 = setTimeout(() => setShow(true), delay * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);
  return show ? (
    refreshPage()
  ) : (
    <React.Fragment>
      <style>
        {`
  .lds-spinner {
    color: #1171ef;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 45%; 
  }
  .lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
  }
  .lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #1171ef;
  }
  .lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  .lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  .lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  .lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  .lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  .lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  .lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  .lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  .lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  .lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  .lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  .lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }        
      `}
      </style>
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <p style={{ textAlign: "center" }}>
        Creating and Checking the connectivity ...
      </p>
    </React.Fragment>
  );
}

export default function HostManagement(props) {
  const { toggleButton, focusAfterCloseButton, openButton } = props;

  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);

  const [selectedValue, setSelectedValue] = React.useState({
    ipaddress: true,
    domainname: true,
  });

  const handleChange1 = (event) => {
    setSelectedValue(event.target.value);
  };

  const [state, setState] = React.useState({
    hostname: "",
    ip_dns: "",
    port: "",
    jumphost_id: "",
    os_type: "",
    credential_id: "",
    errorMessage: "",
    errorMessage1: "",
    domain: "",
    submitted: false,
    newsubmitCheck: false,
  });
  console.log(state);
  const [credlist, setcredlist] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/credentiallist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setcredlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [jumplist, setjumplist] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/jumphostlist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setjumplist(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [hostcheck, setlists] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/hostonlylist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlists(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  function refreshPage() {
    window.location.reload();
  }

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    var hostnamepattern = /^\S+$/;
    if (hostnamepattern.test(state.hostname)) {
      if (state.domain === "") {
        var pattern =
          /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
        if (pattern.test(state.ip_dns)) {
          const getValue = hostcheck.map((row) => {
            if (state.ip_dns === row.ip_dns) {
              return row.is_active;
            }
          });
          var ipdnsstat = getValue.filter(function (el) {
            return el != null;
          });

          if (ipdnsstat[0] === false) {
            if (
              window.localStorage.getItem("audit_run_limit") ===
              "You don't have enough License to perform audit please contact sales@zippyops.com for license renewal"
            ) {
              toggle2();
            } else {
              toggle1();
            }
          } else {
            const host = {
              hostname: state.hostname,
              ip_dns: state.ip_dns,
              jumphost_id: state.jumphost_id,
              os_type: state.os_type,
              credential_id: state.credential_id,
              port: state.port,
            };
            setState({ submitted: true });
            fetch(`${process.env.REACT_APP_API_URL}/api/hosts/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(host),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.id) {
                  setState({ newsubmitCheck: true });
                  window.location.reload();
                } else {
                  if (data.hostname) {
                    setState({ errorMessage: data.hostname[0] });
                  } else if (data.ip_dns) {
                    if (data.ip_dns[0] === "ip address is inactive") {
                      if (
                        window.localStorage.getItem("audit_run_limit") ===
                        "License limitation crossed"
                      ) {
                        toggle2();
                      } else {
                        toggle1();
                      }
                    } else {
                      setState({ errorMessage: data.ip_dns[0] });
                    }
                  } else {
                    setState({ errorMessage1: data.non_field_errors[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        } else {
          setState({ errorMessage: "The IP Address entered is invalid!" });
        }
      }
      if (state.ip_dns === "") {
        const isValidDomain = require("is-valid-domain");
        if (isValidDomain(state.domain)) {
          const getValue = hostcheck.map((row) => {
            if (state.domain === row.ip_dns) {
              return row.is_active;
            }
          });

          var ipdnsstat = getValue.filter(function (el) {
            return el != null;
          });
          if (ipdnsstat[0] === false) {
            if (
              window.localStorage.getItem("audit_run_limit") ===
              "License limitation crossed"
            ) {
              toggle2();
            } else {
              toggle1();
            }
          } else {
            const host = {
              hostname: state.hostname,
              ip_dns: state.domain,
              jumphost_id: state.jumphost_id,
              os_type: state.os_type,
              credential_id: state.credential_id,
              port: state.port,
            };
            setState({ submitted: true });
            fetch(`${process.env.REACT_APP_API_URL}/api/hosts/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(host),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.id) {
                  window.location.reload();
                } else {
                  if (data.hostname) {
                    setState({ errorMessage: data.hostname[0] });
                  } else {
                    setState({ errorMessage: data.non_field_errors[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        } else {
          setState({
            errorMessage: "The Domain Name entered is invalid!",
          });
        }
      }
    } else {
      setState({
        errorMessage: "White space identified in the Host Name!",
      });
    }
  };

  const UpdatetoRecreate = () => {
    const getValue = hostcheck.map((row) => {
      if (state.ip_dns === row.ip_dns) {
        return row.id;
      }
    });

    var Filtered = getValue.filter(function (el) {
      return el != null;
    });

    const host = {
      hostname: state.hostname,
      ip_dns: "",
      jumphost_id: state.jumphost_id,
      os_type: state.os_type,
      credential_id: state.credential_id,
      is_active: "1",
      port: state.port,
      job_log: "Initializing the host communication ...",
      userdata: "",
      webserver_userdata: "",
      docker_userdata: "",
      application_userdata: "",
      platform: "",
      status: "connecting",
    };
    setState({ submitted: true });
    fetch(
      `${process.env.REACT_APP_API_URL}/api/updatetoactivate/${Filtered}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(host),
      }
    )
      .then((response) => response.json(host))
      .then((data) => {
        toggle1();
        refreshPage();
      })
      .catch((error) => {
        toggle1();
        console.log(error);
      });
  };

  const isValidDomain = require("is-valid-domain");

  const [open1, setOpen1] = React.useState(false);
  const focusAfterClose1 = () => {
    setOpen1(true);
  };
  const toggle1 = () => setOpen1(!open1);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const toggle = () => setOpen(!open);

  return (
    <>
      <button
        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-2 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
        onClick={handleClickOpen}
      >
        Add Host
      </button>

      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {state.submitted ? (
          <Progress submitted={state.submitted} refreshPage={refreshPage} />
        ) : (
          <>
            <h2
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "810",
                color: "rgb(48, 68, 115)",
                fontFamily: "sans-serif",
                lineHeight: "4.5rem",
              }}
            >
              Create a Host
            </h2>
            <DialogContent>
              <div>
                {state.errorMessage && (
                  <Alert
                    style={{
                      color: "red",
                      fontSize: "18px",
                      textAlign: "center",
                    }}
                    isOpen={visible}
                    toggle={onDismiss}
                  >
                    {" "}
                    {state.errorMessage}{" "}
                  </Alert>
                )}
              </div>
              <Label htmlFor="name">
                <strong>Host Name</strong>
              </Label>
              <TextField
                fullWidth
                type="text"
                id="hostname"
                className="form-control"
                value={state.hostname}
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Enter a name for the Host"
              />
              {state.hostname ? (
                <p>
                  {" "}
                  {/^\S+$/.test(state.hostname) ? null : (
                    <span style={{ color: "red" }}>
                      *Please enter the Fully Qualified Domain Name without
                      whitespaces
                    </span>
                  )}
                </p>
              ) : (
                ""
              )}{" "}
              <br />
              <br />
              <Row>
                <Col>
                  <Radio
                    checked={selectedValue === "ipaddress"}
                    onChange={handleChange1}
                    value="ipaddress"
                    name="radio-button-demo"
                    inputProps={{ "aria-label": "C" }}
                  />
                  <Label>IP Address</Label>
                  {selectedValue == "ipaddress" ? (
                    <IconButton
                      color="white"
                      size="sm"
                      title="For non Jump-Host connection IP Address should be accessible over the internet"
                      data-toggle="collapse"
                    >
                      <InfoIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    ""
                  )}
                  <Radio
                    checked={selectedValue === "domainname"}
                    onChange={handleChange1}
                    value="domainname"
                    name="radio-button-demo"
                    inputProps={{ "aria-label": "C" }}
                  />
                  <Label>Domain Name</Label>

                  {selectedValue == "domainname" ? (
                    <IconButton
                      color="white"
                      size="sm"
                      title="DNS should be publicly available and accessible over internet"
                      data-toggle="collapse"
                    >
                      <InfoIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              {selectedValue == "domainname" ? (
                <Col md={20}>
                  <TextField
                    type="text"
                    id="domain"
                    className="form-control"
                    value={state.domain}
                    onChange={handleChange}
                    placeholder="Enter the Domain Name of the server"
                    variant="outlined"
                    size="small"
                    fullWidth
                  ></TextField>
                  {state.domain ? (
                    <p>
                      {" "}
                      {isValidDomain(state.domain) ? null : (
                        <span style={{ color: "red" }}>
                          *Invalid domain name
                        </span>
                      )}
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
              ) : selectedValue == "ipaddress" ? (
                <Col md={20}>
                  <TextField
                    type="text"
                    id="ip_dns"
                    className="form-control"
                    value={state.ip_dns}
                    onChange={handleChange}
                    placeholder="Enter the IP Address"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  {state.ip_dns ? (
                    <p>
                      {" "}
                      {/\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                        state.ip_dns
                      ) ? null : (
                        <span style={{ color: "red" }}>*Invalid Ipaddress</span>
                      )}
                    </p>
                  ) : (
                    ""
                  )}{" "}
                </Col>
              ) : (
                ""
              )}
              <br />
              <Label htmlFor="port">
                <strong>Port number</strong>
              </Label>
              <TextField
                className="form-control"
                type="number"
                id="port"
                placeholder="Enter the SSH(22) or WinRM(5985) port number"
                name="port"
                value={state.port}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                required
              ></TextField>
              {state.port ? (
                <p>
                  {" "}
                  {portValidator(state.port).validate() ? null : (
                    <span style={{ color: "red" }}>*Invalid port number</span>
                  )}
                </p>
              ) : (
                ""
              )}
              <br />
              <br />
              <Label htmlFor="os_type">
                <strong> OS type</strong>
              </Label>
              <TextField
                className="form-control"
                type="select"
                id="os_type"
                placeholder="-- Select the OS type --"
                name="os_type"
                value={state.os_type}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                required
                select
                SelectProps={{ native: true }}
              >
                {" "}
                <option>-- Select the OS type --</option>
                <option value="windows">Windows</option>
                <option value="linux">Linux</option>
              </TextField>
              <br />
              <br />
              <FormGroup>
                <Label htmlFor="credential_id">
                  <strong>Credentials</strong>
                </Label>
                <Col md={10}>
                  <FormGroup>
                    <TextField
                      type="select"
                      id="credential_id"
                      className="form-control"
                      value={state.credential_id}
                      onChange={handleChange}
                      placeholder="-- Select the credential --"
                      variant="outlined"
                      size="small"
                      select
                      SelectProps={{ native: true }}
                      fullWidth
                    >
                      <option>-- Select the credential --</option>
                      {credlist.map((credlist) => {
                        return (
                          <React.Fragment>
                            <option value={credlist.id}>{credlist.name}</option>
                          </React.Fragment>
                        );
                      })}
                    </TextField>
                  </FormGroup>
                </Col>
                <FormControlLabel
                  control={<Switch />}
                  label="Jumphost"
                  onClick={showSubnav}
                />
              </FormGroup>
              <br />
              {subnav ? (
                <React.Fragment>
                  <FormGroup>
                    <Label htmlFor="jumphost_id" className="ml-2">
                      <strong>Jump Host</strong>
                    </Label>

                    <TextField
                      type="select"
                      id="jumphost_id"
                      className="form-control"
                      value={state.jumphost_id}
                      onChange={handleChange}
                      placeholder="-- Select the Jump Host --"
                      variant="outlined"
                      size="small"
                      select
                      SelectProps={{ native: true }}
                      fullWidth
                    >
                      <option>-- Select the Jump Host --</option>
                      {jumplist.map((jumplist) => {
                        return (
                          <React.Fragment>
                            <option value={jumplist.id}>{jumplist.name}</option>
                          </React.Fragment>
                        );
                      })}
                    </TextField>
                    <Label htmlFor="auth_method">
                      <small>
                        Select the Jump Host or Bastion Host through which the
                        internal servers has to be connected
                      </small>
                    </Label>
                  </FormGroup>
                </React.Fragment>
              ) : (
                ""
              )}
            </DialogContent>

            <DialogActions>
              <button
                className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                className="bg-lightBlue-500 text-white active:bg-blueGray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                onClick={handleSubmitClick}
              >
                Create
              </button>
              <Dialog
                PaperProps={{
                  sx: {
                    width: "80%",
                  },
                }}
                open={open1}
                keepMounted
                onClose={focusAfterClose1}
                aria-describedby="alert-dialog-slide-description"
              >
                <h2
                  style={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "810",
                    color: "rgb(48, 68, 115)",
                    fontFamily: "sans-serif",
                    lineHeight: "4.5rem",
                  }}
                >
                  Add Host
                </h2>
                <DialogContent style={{ overflowWrap: "anywhere" }}>
                  <a style={{ fontSize: "smaller" }}>
                    IP Address already exist, It is in Inactive state. if you
                    want to Add the IP Address{" "}
                    <strong style={{ color: "red" }}>{state.ip_dns}</strong>,{" "}
                    <strong>Please Click to Activate</strong> ?{" "}
                  </a>
                </DialogContent>
                <DialogActions>
                  <Button
                    className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    onClick={toggle1}
                    size="sm"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="bg-red-400 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    onClick={UpdatetoRecreate}
                    size="sm"
                  >
                    Activate
                  </Button>
                </DialogActions>
              </Dialog>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}